import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";
import logo from "../assets/img/logo_full small.png";

function Footer() {

  // ✅ SCROLL TO TOP FUNCTION
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // agar instant chahiye ho to "auto"
    });
  };

  return (
    <footer className="site-footer">
      <div className="footer-wrap">

        {/* Brand */}
        <div className="footer-col footer-brand">
          <h3 className="footer-logo">
            <img
              src={logo}
              alt="MedTech Logo"
              style={{ height: 100, width: "70" }}
            />
          </h3>

          <p className="footer-text">
            We create scalable MedTech solutions that connect Medical Technology, and dependable healthcare services.
          </p>

          <div className="footer-social">
            <a href="/" className="social-btn"><FaFacebookF /></a>
            <a href="/" className="social-btn"><FaTwitter /></a>
            <a href="https://www.instagram.com/sasinnovates/" className="social-btn"><FaInstagram /></a>
            <a href="https://www.linkedin.com/in/sudhanshu-and-sidharth-innovations-pvt-ltd-45698a3b5/" className="social-btn"><FaLinkedinIn /></a>
          </div>
        </div>

        {/* Company */}
        <div className="footer-col">
          <h4 className="footer-title">Company</h4>
          <ul className="footer-links">
            <li><Link to="/" onClick={scrollToTop}>Home</Link></li>
            <li><Link to="/about" onClick={scrollToTop}>About</Link></li>
            <li><Link to="/Career" onClick={scrollToTop}>Careers</Link></li>
            <li><Link to="/investors" onClick={scrollToTop}>For Investors</Link></li>
            <li><Link to="/Contact" onClick={scrollToTop}>Contact</Link></li>
          </ul>
        </div>

        {/* Services */}
        <div className="footer-col">
          <h4 className="footer-title">Products and Technology</h4>
          <ul className="footer-links">
            <li><Link to="/OurTechnology" onClick={scrollToTop}>Our Technology</Link></li>
            <li><Link to="/" onClick={scrollToTop}>Clinical validation</Link></li>
            <li><Link to="/Products" onClick={scrollToTop}>Products</Link></li>
            <li><Link to="/partners" onClick={scrollToTop}>Our Partners</Link></li>
            <li><Link to="/news" onClick={scrollToTop}>News & updates</Link></li>
          </ul>
        </div>

        {/* Offices Section */}
        <div className="footer-col footer-offices">
          <h4 className="footer-title">Our Offices</h4>

          <div className="offices-grid">

            {/* Branch Office */}
            <div className="office-card">
              <h5 className="office-title">Branch Office (Kanpur)</h5>

              <p className="office-line">
                <FaMapMarkerAlt className="ico" />
                <span>
                  31C Gulistan Mart, Emerald Gulistan,
                  Jajmau, Kanpur, Uttar Pradesh
                </span>
              </p>

              <p className="office-line">
                <FaPhoneAlt className="ico" />
                <span>+91 8802123273</span>
              </p>

              <p className="office-line">
                <FaEnvelope className="ico" />
                <span>sasinnovates@gmail.com</span>
              </p>

              <div className="map-box">
                <iframe
                  title="Branch Office Map"
                  src="https://www.google.com/maps?q=31C+Gulistan+Mart+Emerald+Gulistan+Jajmau+Kanpur+Uttar+Pradesh&output=embed"
                  loading="lazy"
                  allowFullScreen
                />
              </div>
            </div>

            {/* Head Office */}
            <div className="office-card">
              <h5 className="office-title">Head Office (Lucknow)</h5>

              <p className="office-line">
                <FaMapMarkerAlt className="ico" />
                <span>
                  5/126, Vikas Khand 5, Gwari Village,
                  Gomati Nagar, Lucknow, UP – 226010
                </span>
              </p>

              <p className="office-line">
                <FaPhoneAlt className="ico" />
                <span>+91 9871203987</span>
              </p>

              <p className="office-line">
                <FaEnvelope className="ico" />
                <span>sasinnovates@gmail.com</span>
              </p>

              <div className="map-box">
                <iframe
                  title="Head Office Map"
                  src="https://www.google.com/maps?q=5/126+Vikas+Khand+5+Gwari+Village+Gomati+Nagar+Lucknow+Uttar+Pradesh+226010&output=embed"
                  loading="lazy"
                  allowFullScreen
                />
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} Sudhanshu & Siddharth Innovations Pvt. Ltd.
        All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
